import { createContext } from 'react';

export const MatomoInstanceContext = createContext({});
